import { render } from "./BoostSales.vue?vue&type=template&id=a4e9bc70"
import script from "./BoostSales.vue?vue&type=script&lang=js"
export * from "./BoostSales.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\USER\\Desktop\\New folder\\Lynkme360\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__